import React from 'react';
import { Button } from '@tt/ui';
import { useEmptyState } from '../../context';
const sizeMap = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
};
const PrimaryButton = (props) => {
    const { size } = useEmptyState();
    return React.createElement(Button, { width: 232, size: sizeMap[size], ...props });
};
export default PrimaryButton;
